export default "__VITE_PUBLIC_ASSET__31ef2239__"